import styles from './ModsView.module.css';
import ModPanel from './components/ModPanel';
import WorkshopPanel from './components/WorkshopPanel';

const ModsView = () =>
{
	return (
		<div className={styles.modsView}>
			<ModPanel />
			<WorkshopPanel />
		</div>
	);
};

export default ModsView;
